/* eslint-disable @typescript-eslint/no-var-requires */

export const getInnerHtmlTag = (content: string) => {
  let title;
  if (content) {
    const result = content.match(/<h2(.*)<\/h2>/);
    title = result?.[0].replace(/<[^>]*>/g, '');
  }
  return title;
};
